import React, { Component } from 'react'

import Bus from '../utils/bus'
let BUS = new Bus()

let scrollThreshold = 80

export default class ScrollMaster extends Component {
  constructor(props) {
    super(props)
    this.state = {
      previousPos: null,
      scrollPos: null,
      direction: null,
      scrollPosBeforeChange: null,
    }
    this.checkPosition = this.checkPosition.bind(this)
    this.updatePosition = this.updatePosition.bind(this)
  }

  componentDidMount() {
    if (typeof window !== `undefined`) {
      this.scroll = window.requestAnimationFrame(this.checkPosition)
    }
  }
  componentWillUnmount() {
    if (typeof window !== `undefined`) {
      window.cancelAnimationFrame(this.scroll)
    }
  }

  checkPosition() {
    const y = window.pageYOffset

    this.setState(
      {
        scrollPos: y,
        previousPos: y,
      },
      this.updatePosition(y)
    )
    this.scroll = window.requestAnimationFrame(this.checkPosition)
  }

  updatePosition(y) {
    const previousPos = this.state.previousPos
    let newDirection = this.state.direction
    let newState = {}

    if (y > previousPos) {
      newDirection = 'down'
    } else if (y < previousPos) {
      newDirection = 'up'
    }

    if (
      newDirection !== this.state.direction &&
      this.state.scrollPosBeforeChange === null
    ) {
      newState.scrollPosBeforeChange = y
    }

    if (this.state.scrollPosBeforeChange !== null) {
      let yDiff = Math.abs(y - this.state.scrollPosBeforeChange)
      if (yDiff > scrollThreshold) {
        newState.scrollPosBeforeChange = null
        BUS.trigger('update-direction', {
          direction: newDirection,
        })
      }
    }

    BUS.trigger('update-position', {
      position: y,
    })

    newState.y = y
    newState.direction = newDirection
    newState.previousPos = this.state.direction

    this.setState(newState)
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/scroll-master.js